import { Role } from '@agilox/common';
import { analyticsMobileMenuPoints } from './analytics-menupoints';
import { MenuPoint } from '@agilox/ui-common';

/** mobile menu points*/
export const mobileMenuPoints: MenuPoint[] = [
	analyticsMobileMenuPoints.aiInsights,
	{
		name: 'general.menu.menu',
		url: '',
		icon: 'menu_hamburger',
		roles: [Role.superuser, Role.support, Role.service, Role.partner, Role.customer],
		submenus: [
			analyticsMobileMenuPoints.aiInsights,
			analyticsMobileMenuPoints.dashboard,
			analyticsMobileMenuPoints.processes,
			analyticsMobileMenuPoints.failures,
			analyticsMobileMenuPoints.help,
			analyticsMobileMenuPoints.logout,
		],
	},
];
